<template>
  <div
    class="filter"
    v-on:click="openFilter"
  >
    <svg width="35" height="35" xmlns="http://www.w3.org/2000/svg"><path d="M17.5 35C7.835 35 0 27.165 0 17.5S7.835 0 17.5 0 35 7.835 35 17.5 27.165 35 17.5 35zM10 14h14.945v-2H10v2zm0 5h14.945v-2H10v2zm0 5h14.945v-2H10v2z" fill="#FFF" fill-rule="evenodd"/></svg>
  </div>
</template>

<script>
import { Bus } from '@/components/Bus'

export default {
  name: 'MobileNav',
  data () {
    return {

    }
  },
  methods: {
    openFilter: function () {
      Bus.$emit('openFilter')
    }
  }
}
</script>

<style lang="scss" scoped>

@import '../styles/core/vars.scss';
@import '../styles/core/mixins.scss';

.filter {
  display: block;
  position: fixed;
  top: 20px;
  right: 20px;
  cursor: pointer;
  z-index: 10;

  svg {
    transition: all 0.2s ease-in-out;
  }

  &:hover {
    svg {
      opacity: 0.7;
    }
  }

  @include respond-to('medium') {
    display: none;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/MobileNav.vue